// components/CtaBanner.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import './PageHeader.css';

const CtaBanner = ({
    title = 'Have a project in mind?',
    text = 'Tell us what you need and get a free consultation and proposal within 24 hours.',
}) => {
    return (
        <section className="cta-banner">
            <div className="container">
                <div className="cta-banner-inner">
                    <div>
                        <h3>{title}</h3>
                        <p>{text}</p>
                    </div>
                    <div className="cta-banner-actions">
                        <Link to="/contact" className="btn">
                            Get Free Quote <FaChevronRight />
                        </Link>
                        <a href="https://wa.me/923098373032" className="btn btn-outline" target="_blank" rel="noopener noreferrer">
                            WhatsApp Us
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaBanner;
